import "./MyGamesPage.style.css";

import { useEffect, useState } from "react";
import { MyGamesTable } from "./MyGamesTable/MyGamesTable";
import { GameCardState } from "../../utils/states/ConstructorPageStates/GameCardState";
import { ApiFactory } from "../../api-client/api-factory";
import { GameCardDto, GamesApi } from "../../api-client";
import { GameCardMapper } from "../../utils/mappers/GameCardMapper";
import { UniqueId } from "../../utils/UniqueId";
import { useIsMobile } from "../../utils/functions/useIsMobile";

interface MyGamesPageProps {
  username: string;
}

export const MyGamesPage = ({ username }: MyGamesPageProps) => {
  const isMobile = useIsMobile();

  const [myGameCards, setMyGameCards] = useState<GameCardState[]>([]);
  const [isMyGamesReceived, setIsMyGamesReceived] = useState<boolean>(false);

  useEffect(() => {
    UniqueId.clear();

    ApiFactory.get(GamesApi)
      .gamesOwnGet()
      .then((response) => {
        setMyGameCards(
          GameCardMapper.toGameCardStates(response.games as GameCardDto[]),
        );
        setIsMyGamesReceived(true);
      })
      .catch(() => {
        console.error('Не получилось получить список "моих" игр');
        setIsMyGamesReceived(true);
      });
  }, []);

  return (
    <div className="my-games-page">
      {isMobile ? (
        <div className="my-games-page__no-mobile">
          К сожалению, конструктор пока недоступен на мобильных устройствах :(
        </div>
      ) : (
        <>
          <div className="my-games-page__title">Мои проекты</div>
          <MyGamesTable
            gameCards={myGameCards}
            isMyGamesReceived={isMyGamesReceived}
            username={username}
          />
        </>
      )}
    </div>
  );
};
